import Vue from "vue";
import VueRouter from "vue-router";
import RouterPrefetch from "vue-router-prefetch";
import DashboardPlugin from "./plugins/dashboard-plugin";
import App from "./App.vue";
import "leaflet/dist/leaflet.css";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import { Icon } from "leaflet";
import NetworkService from "./util/netservice";
import objectToCsv from "./util/JSON2CSV";
import util from "./util/util";
import io from "socket.io-client";
import VueSocketIO from "vue-socket.io";
import VueWorker from "vue-worker";
import swal from "sweetalert2";
import VueCookies from "vue-cookies";
import VueCompositionApi from "@vue/composition-api";

Vue.use(VueCookies);
Vue.prototype.$cookie = VueCookies;
Vue.$cookies.config("1d");

// import Worker from 'worker-loader';

import moment from "moment-timezone";

moment.tz.setDefault("Asia/Kuala_Lumpur");
// Vue.use(io)
//inject
Vue.prototype.moment = moment;
Vue.prototype.$CSV = objectToCsv;
Vue.prototype.$http = NetworkService;
Vue.prototype.$sio = io;

// router setup
import router from "./routes/router";
import i18n from "./i18n";
import BootstrapVue from "bootstrap-vue";

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueRouter);
Vue.use(RouterPrefetch);
Vue.use(BootstrapVue);
Vue.use(VueCompositionApi);
// Vue.use(VueWorker);
// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: "https://alpha.vectolabs.com:9991",

//   options: { path: ":10001/api/v1/ws/socket.io/" } //Optional options
// }))
Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-marker", LMarker);

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
/* eslint-disable no-new */
new Vue({
  // created() {
  //   util.tokenPing()
  // window.onbeforeunload = e => {
  //   // util.logoutOnRefresh();

  //   return "logout";
  // };
  // },
  el: "#app",
  render: (h) => h(App),
  router,
  i18n,
});
